export const LoginUrlHelper = {
  GetDestPath,
};

function GetDestPath(pathName) {
  let destPath;
  if (process.env.REACT_APP_HOME) {
    var pathRegExp = new RegExp("/" + process.env.REACT_APP_HOME + "/?");
    destPath = pathName.replace(pathRegExp, "/");
  } else {
    destPath = pathName;
  }
  return destPath;
}
